import InnerComponent from '@Components/Purchase/PurchaseOrders/POForm';
import orgContainer from '@Components/AppContainer';

const OrgCreatePurchaseOrders = () => (orgContainer(InnerComponent));
export default OrgCreatePurchaseOrders;
